import { createSlice, isAnyOf, isPending, isRejected, isFulfilled, isRejectedWithValue  } from '@reduxjs/toolkit';
import { getPopupThunk } from './thunks'

const initialState = {
  loading: true,
  imgPath: null,
  error: null,
  errorDescription: {},
  message: null
};

export const pop_upsSlice = createSlice({
  name: 'pop_ups',
  initialState,
  extraReducers: builder => {
    builder
    .addMatcher( 
      isPending(getPopupThunk ),
      (state) => {
        state.loading = true;
        state.error = null;
        state.errorDescription = {};
        state.message = null;
      }
    )
 
    .addMatcher(
      isFulfilled(getPopupThunk),
      (state, action) => {
        console.log(action.payload)
        state.loading = false;
        state.imgPath = action.payload.pop_up?.imgPath;
        state.imgPathMobile = action.payload.pop_up?.imgPathMobile;
        state.visible = action.payload.pop_up?.visible;
        state.message = action.payload.message;
      }
    )

   .addMatcher(
      isRejectedWithValue(getPopupThunk),
      (state, action) => {
        state.loading = false;
        state.errorDescription = action.payload;
        state.error = {
          message: action.payload.message,
        } 
      }
    )
  }
});



export default pop_upsSlice.reducer;
